import { Component, OnDestroy, OnInit } from '@angular/core';
import { InteractionService } from '../services/interaction.service';
import { TccDetailService } from '../services/tcc-detail.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-purpose',
  templateUrl: './purpose.component.html',
  styleUrls: ['./purpose.component.scss']
})
export class PurposeComponent implements OnDestroy, OnInit {

  public purposes:any=null;
  public selectedPurpose: number =5;
  dtOptions: DataTables.Settings = {};
  // We use this trigger because fetching the list of purpose can be quite long,
  // thus we ensure the data is fetched before rendering
  dtTrigger: Subject<any> = new Subject();

  constructor(private tccservice : TccDetailService,private inters:InteractionService) { }
  

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 5,
      processing: true
    };
    this.tccservice.getPurpose().subscribe(data=>{
      this.purposes=data;
      // Calling the DT trigger to manually render the table
        this.dtTrigger.next();
        console.log(this.purposes);
    });
  }

  sendPurposeId(id:number){
    this.selectedPurpose = id;
     this.inters.sendMessage(id);
     Swal.fire("Purpose selected. ID = "+id+". Close Purpose Screen, confirm Period, and proceed with Approval.");
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

}
